/* The Print Doctor — reveals, hero parallax, header state. Tiny, dependency-free. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;
  if (document.querySelector('.pd-hero')) body.classList.add('pd-home');

  // scroll reveals
  var els = document.querySelectorAll('.pd-reveal, .pd-cta');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }

  // ---- signature layer (grain, vignette, heartbeat scrollbar; cursor + spotlight on fine pointers) ----
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function mk(cls, html) { var d = document.createElement('div'); d.className = cls; if (html) d.innerHTML = html; document.body.appendChild(d); return d; }
  var pulse = mk('pd-pulse', '<i class="pd-pulse__track"></i><i class="pd-pulse__fill"></i>');
  var pulseFill = pulse.lastElementChild;
  var spot = null, ptX = -100, ptY = -100, spX = -100, spY = -100;
  if (!reduce) { mk('pd-vignette'); mk('pd-grain'); }
  if (fine && !reduce) {
    spot = mk('pd-spotlight');
    window.addEventListener('pointermove', function (e) { ptX = e.clientX; ptY = e.clientY; }, { passive: true });
    (function loop() {
      spX += (ptX - spX) * 0.18; spY += (ptY - spY) * 0.18;
      spot.style.transform = 'translate(' + spX.toFixed(1) + 'px,' + spY.toFixed(1) + 'px)';
      requestAnimationFrame(loop);
    })();
    // magnetic controls: nudge toward the pointer while hovered
    document.querySelectorAll('.pd-btn, .button, .header-actions__action, .pd-cat__more i').forEach(function (el) {
      el.classList.add('pd-magnet');
      var k = el.classList.contains('pd-btn') || el.classList.contains('button') ? 0.22 : 0.3;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' + ((e.clientX - (r.left + r.width / 2)) * k).toFixed(1) + 'px,' + ((e.clientY - (r.top + r.height / 2)) * k).toFixed(1) + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
    // pointer tilt on product cards
    document.querySelectorAll('.pd-card').forEach(function (card) {
      var m = card.querySelector('.pd-card__media'); if (!m) return;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var nx = (e.clientX - r.left) / r.width - 0.5, ny = (e.clientY - r.top) / r.height - 0.5;
        m.style.transform = 'rotateX(' + (-ny * 7).toFixed(2) + 'deg) rotateY(' + (nx * 7).toFixed(2) + 'deg) scale(1.02)';
      });
      card.addEventListener('mouseleave', function () { m.style.transform = ''; });
    });
  }
  // hover-to-play band videos (touch: play while mostly in view)
  var hv = document.querySelectorAll('[data-pd-hover-video]');
  if (!reduce && hv.length) {
    hv.forEach(function (v) {
      var host = v.closest('.pd-cat');
      function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); host.classList.add('is-playing'); }
      function stop() { v.pause(); host.classList.remove('is-playing'); }
      if (fine) { host.addEventListener('mouseenter', play); host.addEventListener('mouseleave', stop); }
      else if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { e.intersectionRatio > 0.6 ? play() : stop(); }); }, { threshold: [0, 0.6, 1] }).observe(host);
      }
    });
  }
  var heroVideo = document.querySelector('.pd-hero__video');
  if (heroVideo && reduce) { heroVideo.pause(); heroVideo.remove(); }

  // lane index: hovering / focusing a line brings its backdrop up (the real clips play, stock stays muted)
  var idx = document.querySelector('[data-pd-index]');
  if (idx) {
    var layers = idx.querySelectorAll('[data-pd-layer]'), rows = idx.querySelectorAll('[data-pd-row]');
    var current = '';
    function showLane(i) {
      if (i === current) return; current = i;
      layers.forEach(function (l) {
        var on = l.getAttribute('data-pd-layer') === i; l.classList.toggle('is-on', on);
        var v = l.querySelector('video');
        if (v) { if (on && !reduce && fine) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }
      });
      rows.forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-pd-row') === i); });
    }
    rows.forEach(function (r) {
      r.addEventListener('mouseenter', function () { showLane(r.getAttribute('data-pd-row')); });
      r.addEventListener('focus', function () { showLane(r.getAttribute('data-pd-row')); });
    });
    if (rows.length) showLane(rows[0].getAttribute('data-pd-row'));
  }

  // Horizon scrolls the .page-wrapper element, not the window (html/body are
  // overflow:hidden), so read scroll position from whichever one actually moves.
  var scroller = document.querySelector('.page-wrapper');
  if (!scroller || scroller.scrollHeight <= scroller.clientHeight) scroller = null;
  var media = document.querySelector('.pd-hero__media');
  var ticking = false;
  function scrollY() { return scroller ? scroller.scrollTop : (window.scrollY || 0); }
  function frame() {
    ticking = false;
    var y = scrollY();
    body.classList.toggle('pd-scrolled', y > 40);
    var max = scroller ? (scroller.scrollHeight - scroller.clientHeight) : (document.documentElement.scrollHeight - window.innerHeight);
    if (pulseFill) pulseFill.style.clipPath = 'inset(0 ' + ((1 - Math.min(1, Math.max(0, y / Math.max(1, max)))) * 100).toFixed(2) + '% 0 0)';
    if (media && !reduce && y < window.innerHeight * 1.2) media.style.transform = 'translate3d(0,' + (y * 0.18).toFixed(1) + 'px,0)';
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  (scroller || window).addEventListener('scroll', onScroll, { passive: true });
  frame();
})();
